var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      staticClass: "no-border",
      attrs: {
        id: "select-risk-level-search",
        "no-label": "",
        label: _vm.$t("global.words.search"),
        "hidden-label": "",
      },
    },
    [
      _c("v-select-field", {
        staticClass: "search-input w-100",
        attrs: {
          options: _vm.riskLevelOptions,
          placeholder: _vm.$t("global.actions.chooseOption"),
          label: "text",
          clearable: _vm.clearable,
          "default-value": _vm.localSelectedRiskLevels,
          multiple: "",
          "has-checkboxes": "",
          "deselect-from-dropdown": "",
          action: _vm.actionRef,
          scenario: "riskLevel",
        },
        on: {
          "option:selected": _vm.handleChange,
          "option:deselected": _vm.handleChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }